module.exports = __webpack_public_path__ + "static/media/points-up.d2405e70.svg";